import type { DisplaySource } from '@pokerroom/types';
import { useTranslation } from 'react-i18next';
import './history-source.css';

/** Unknown legacy notes remain available by explicit disclosure, never by text heuristics. */
export function HistorySource({
  source,
  note,
  technical = false,
}: {
  source?: DisplaySource;
  note?: string | null;
  technical?: boolean;
}) {
  const { t } = useTranslation('common');
  const kind = source?.kind ?? 'OTHER';
  const manual = source?.noteKind === 'MANUAL';
  return (
    <div className="history-source" data-technical={technical ? 'true' : 'false'}>
      {manual ? (
        note || '—'
      ) : (
        <>
          <span>
            {source?.name ?? t('historySource.unavailable')} · {t(`historySource.${kind}`)}
          </span>
          {source?.nameEvidence === 'CURRENT_REFERENCE' && (
            <small className="block text-base-content/60">{t('historySource.current')}</small>
          )}
          {source?.reversalReason && <small className="block">{source.reversalReason}</small>}
        </>
      )}
      {!manual &&
        note &&
        (technical ? (
          <div className="history-source-technical">{note}</div>
        ) : (
          <details className="original-note-disclosure">
            <summary className="min-h-11 cursor-pointer">{t('historySource.original')}</summary>
            <div>{note}</div>
          </details>
        ))}
    </div>
  );
}
